export const APP_ENVIRONMENTS = ['development', 'preview', 'production'] as const;

export type AppEnvironment = (typeof APP_ENVIRONMENTS)[number];

export function isValidAppEnvironment(value: string): value is AppEnvironment {
  return (APP_ENVIRONMENTS as readonly string[]).includes(value);
}

export function assertAppEnvironment(value: string | undefined): AppEnvironment {
  if (!value || !isValidAppEnvironment(value)) {
    throw new Error(
      `Invalid APP_ENV "${value ?? 'undefined'}". Expected one of: ${APP_ENVIRONMENTS.join(', ')}`,
    );
  }
  return value;
}

export function isProduction(env: AppEnvironment): boolean {
  return env === 'production';
}

export function isPreview(env: AppEnvironment): boolean {
  return env === 'preview';
}

export function isDevelopment(env: AppEnvironment): boolean {
  return env === 'development';
}
